module.exports = __webpack_public_path__ + "static/1_1_defineai_RO-28990cb3bb628f31751b3a888f52f6c2.svg";